;(function (angular, numeral) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('reverse', reverseFilter)

  reverseFilter.$inject = []

  function reverseFilter () {
    return function (items) {
      return items.slice().reverse()
    }
  }
})(window.angular, window.numeral)
